import { hydrate, render } from 'preact';
import { App } from './app';
import './legacy.css';
import './styles.css';

const root = document.getElementById('app');
const app = <App initialPath={location.pathname}/>;
if (root.querySelector('#container')) hydrate(app,root);
else render(app,root);
